import { render, staticRenderFns } from "./sk-file.vue?vue&type=template&id=33f2b1dd&scoped=true&"
import script from "./sk-file.vue?vue&type=script&lang=js&"
export * from "./sk-file.vue?vue&type=script&lang=js&"
import style0 from "./sk-file.vue?vue&type=style&index=0&id=33f2b1dd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f2b1dd",
  null
  
)

export default component.exports